var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanreqi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_30_113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61997 4.00918L15.3265 6.10017L14.7987 6.51016L3.94617 3.90378L4.48453 3.5L6.61997 4.00918ZM2.85522 4.72199L3.3973 4.31543L14.2642 6.92528L13.7364 7.33526L2.85522 4.72199ZM1.85844 5.46957L2.40052 5.06301L13.2937 7.67916L12.7659 8.08915L1.85844 5.46957ZM12.1696 8.5523L11.7036 8.9143L0.875 6.20715L1.26482 5.91478L12.1696 8.5523Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_30_113",
    maskUnits: "userSpaceOnUse",
    x: -0.0522461,
    y: 2.1554,
    width: 17,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.0522461,
    y: 2.1554,
    width: 17,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.947754 6.89637L4.55731 4.1554L15.414 6.74409V7.73072L15.386 7.75533V8.35284L12.0171 11.3061L0.94788 8.35284V7.88302L0.947754 7.88299V6.89637Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.947754 6.89637L4.55731 4.1554L15.414 6.74409V7.73072L15.386 7.75533V8.35284L12.0171 11.3061L0.94788 8.35284V7.88302L0.947754 7.88299V6.89637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55731 4.1554L4.77839 3.22821L4.33989 3.12365L3.98087 3.39628L4.55731 4.1554ZM0.947754 6.89637L0.371307 6.13725L-0.00542504 6.42333V6.89637H0.947754ZM15.414 6.74409H16.3672V5.99147L15.6351 5.81691L15.414 6.74409ZM15.414 7.73072L16.0432 8.44671L16.3672 8.16201V7.73072H15.414ZM15.386 7.75533L14.7568 7.03933L14.4328 7.32404V7.75533H15.386ZM15.386 8.35284L16.0143 9.0696L16.3392 8.78483V8.35284H15.386ZM12.0171 11.3061L11.7714 12.2271L12.2629 12.3582L12.6455 12.0229L12.0171 11.3061ZM0.94788 8.35284H-0.0052985V9.08505L0.702169 9.27381L0.94788 8.35284ZM0.94788 7.88302H1.90106V7.13925L1.1796 6.95844L0.94788 7.88302ZM0.947754 7.88299H-0.00542504V8.62676L0.716033 8.80758L0.947754 7.88299ZM3.98087 3.39628L0.371307 6.13725L1.5242 7.65549L5.13376 4.91451L3.98087 3.39628ZM15.6351 5.81691L4.77839 3.22821L4.33623 5.08258L15.1929 7.67128L15.6351 5.81691ZM16.3672 7.73072V6.74409H14.4608V7.73072H16.3672ZM16.0152 8.47133L16.0432 8.44671L14.7848 7.01472L14.7568 7.03933L16.0152 8.47133ZM14.4328 7.75533V8.35284H16.3392V7.75533H14.4328ZM14.7577 7.63608L11.3888 10.5893L12.6455 12.0229L16.0143 9.0696L14.7577 7.63608ZM12.2628 10.3851L1.19359 7.43188L0.702169 9.27381L11.7714 12.2271L12.2628 10.3851ZM1.90106 8.35284V7.88302H-0.0052985V8.35284H1.90106ZM0.716033 8.80758L0.71616 8.80761L1.1796 6.95844L1.17947 6.95841L0.716033 8.80758ZM-0.00542504 6.89637V7.88299H1.90093V6.89637H-0.00542504Z",
    fill: "black",
    mask: "url(#path-2-outside-1_30_113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.947998 8.3829V6.9035L15.3861 6.74402V8.3829L12.0172 11.3362L0.947998 8.3829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55766 4.1554L0.94812 6.86255L11.7767 9.5697L15.4144 6.74409L4.55766 4.1554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69429 4.66489L15.3995 6.75556L14.8717 7.16555L4.01917 4.55917L4.55753 4.1554L6.69429 4.66489ZM2.92822 5.37738L3.4703 4.97082L14.3372 7.58067L13.8094 7.99066L2.92822 5.37738ZM1.93144 6.12497L2.47352 5.7184L13.3667 8.33456L12.8389 8.74454L1.93144 6.12497ZM12.2426 9.20769L11.7766 9.5697L0.947998 6.86255L1.33782 6.57018L12.2426 9.20769Z",
    fill: "#F8F8F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_30_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanreqi);
export default __webpack_public_path__ + "static/media/sanreqi.655722ccd0f6c555b0d75decbcfab333.svg";
export { ForwardRef as ReactComponent };